import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect } from "react";
import { StyledPositionComponent } from "./position-component.scss";
import { getDeptInfo } from "components/pages/careers/careers-service";
import TagComponent from "./tag/tag-component";
import { ArrowIcon } from "./arrow-icon";
import { getLocationInfoFromPosition } from "../utils";
import Locations from "../../locations/locations";
import { shouldDisplayInternalTag } from "services/careers/internal-positions-service";
import * as Sentry from "@sentry/nextjs";
const PositionComponent = ({ position, onClick, link })=>{
    const department = getDeptInfo(position);
    const { name } = position;
    const location = useMemo(()=>{
        return getLocationInfoFromPosition(position);
    }, [
        position
    ]);
    useEffect(()=>{
        if (!location) {
            Sentry.captureException(new Error("Position missing location data"), {
                extra: {
                    positionName: position === null || position === void 0 ? void 0 : position.name,
                    positionUid: position === null || position === void 0 ? void 0 : position.uid,
                    positionLocation: position === null || position === void 0 ? void 0 : position.location,
                    positionDepartment: position === null || position === void 0 ? void 0 : position.department
                }
            });
        }
    }, [
        location,
        position
    ]);
    const Icon = useMemo(()=>{
        var _Locations_find;
        return (location === null || location === void 0 ? void 0 : location.id) ? (_Locations_find = Locations.find(({ id })=>id === location.id)) === null || _Locations_find === void 0 ? void 0 : _Locations_find.Icon : null;
    }, [
        location
    ]);
    return /*#__PURE__*/ _jsxs(StyledPositionComponent, {
        onClick: onClick,
        href: link,
        className: "position-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "position-name",
                children: name
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "tags",
                children: [
                    department && /*#__PURE__*/ _jsx(TagComponent, {
                        text: department === null || department === void 0 ? void 0 : department.name
                    }),
                    location && /*#__PURE__*/ _jsx(TagComponent, {
                        text: location.name,
                        Icon: Icon
                    }),
                    shouldDisplayInternalTag(position) && /*#__PURE__*/ _jsx("span", {
                        className: "internal-tag",
                        children: "Internal"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "arrow-container",
                children: /*#__PURE__*/ _jsx(ArrowIcon, {})
            })
        ]
    });
};
export default PositionComponent;
